import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import {
  getFreeGuideBasicDetailsApi,
  getGuideBasicDetailsApi,
} from "../../../api/candidate";
import WebUtils from "../../../utils/WebUtils";
import PrepareMain from "../../../components/candidate/preparation/viewGuide/prepareMain/PrepareMain";

function LearnOrPractice() {
  const { jobGuideIdentifier } = useParams();
  const [searchParams] = useSearchParams();
  const industryId = searchParams.get("industryId");

  const [loading, setLoading] = useState(false);
  const [basicGuideDetails, setBasicGuideDetails] = useState(null);

  const getBasicGuideDetails = () => {
    let url = "";
    if (industryId) {
      url = `${getFreeGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    } else {
      url = `${getGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    }

    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBasicGuideDetails(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (jobGuideIdentifier) getBasicGuideDetails();
  }, [jobGuideIdentifier]);

  return (
    <>
      {loading && <Loader />}

      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="preparation" userRole="candidate" />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="preparation"
            userRole="candidate"
            newTitle={`Prepare Guide (${basicGuideDetails?.jobTitle || "N/A"})`}
          />
          <div className="min-h-[82vh] flex flex-col justify-center items-center py-[1.2rem] px-[0.8rem] lg:px-6">
            <PrepareMain
              basicGuideDetails={basicGuideDetails}
              industryId={industryId}
              jobGuideIdentifier={jobGuideIdentifier}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default LearnOrPractice;
